import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M21 21l-6 -6","key":"svg-1"}],["path",{"d":"M10 13l0 .01","key":"svg-2"}],["path",{"d":"M10 10a1.5 1.5 0 1 0 -1.14 -2.474","key":"svg-3"}]]

const IconZoomQuestion = createReactComponent('outline', 'zoom-question', 'ZoomQuestion', __iconNode);

export default IconZoomQuestion;